var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingBlock",class:[
    ("bg-" + _vm.color),
    ("shimmer-" + _vm.color)
  ],style:({ width: _vm.width, height: _vm.height, borderRadius: (_vm.radius + "px"), marginLeft: _vm.marginLeft, marginRight: _vm.marginRight, marginTop: _vm.marginTop, marginBottom: _vm.marginBottom})})}
var staticRenderFns = []

export { render, staticRenderFns }